import GenericButton from "@ui-components/Button/GenericButton";
import React from "react";

export interface RadioOptionProps {
	value: string;
	label: React.ReactNode;
	icon?: React.ReactNode;
	selectedValue?: string;
	onChange: (value: string) => void;
}

const RadioOption: React.FC<RadioOptionProps> = ({
	value,
	label,
	icon,
	selectedValue,
	onChange,
}) => {
	return (
		<div className="flex items-center space-x-2 p-2 rounded-lg hover:bg-semantic-bg-primary">
			<input
				type="radio"
				value={value}
				checked={selectedValue === value}
				onChange={() => onChange(value)}
				className="w-5 h-5 text-semantic-text-brand focus:bg-semantic-bg-brand-primary"
			/>
			<label className="flex-1 cursor-pointer">{label}</label>
      {icon || (
			<GenericButton
				variant="brand"
				shape="ghost"
				isIconOnly={true}
				slotLeft={icon}
			/>
      )}
		</div>
	);
};

export default RadioOption;
